import { createSlice } from '@reduxjs/toolkit';
import {
    fetchServerDate,
    resetServerDate,
    changeServerDate,
    getTimeRewind,
    fetchEmails,
} from '../thunks/debugThunks.js';

const initialState = {
    loading: false,
    serverDate: '',
    emails: [],
    loadingEmails: false,
    rewindId: null,
    status: false,
};

const debugSlice = createSlice({
    name: 'debug',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchServerDate.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchServerDate.fulfilled, (state, action) => {
                state.loading = false;
                state.serverDate = action.payload;
            })
            .addCase(fetchServerDate.rejected, (state) => {
                state.loading = false;
            })
            .addCase(resetServerDate.pending, (state) => {
                state.loading = true;
            })
            .addCase(resetServerDate.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(resetServerDate.rejected, (state) => {
                state.loading = false;
            })
            .addCase(changeServerDate.pending, (state) => {
                state.loading = true;
            })
            .addCase(changeServerDate.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.loading = action.payload.status;
            })
            .addCase(changeServerDate.rejected, (state) => {
                state.loading = false;
            })
            .addCase(getTimeRewind.fulfilled, (state, action) => {
                Object.assign(state, action.payload);
                state.loading = action.payload.status;
            })
            .addCase(getTimeRewind.rejected, (state) => {
                state.loading = false;
            })
            .addCase(fetchEmails.pending, (state) => {
                state.loadingEmails = true;
            })
            .addCase(fetchEmails.fulfilled, (state, action) => {
                state.emails = action.payload;
                state.loadingEmails = false;
            })
            .addCase(fetchEmails.rejected, (state) => {
                state.loadingEmails = false;
            })
            .addDefaultCase((state) => state);
    },
});

export default debugSlice.reducer;
